import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useMemo, useState, useCallback } from "react";
import { getClassNameFactory } from "@dcl/ui";
import { ToastWrapperPosition } from "./ToastTypes";
import { v4 as uuid } from "uuid";
import { createPortal } from "react-dom";
import { Toast } from "./Toast";
import { DEFAULT_MAX_STACKED_TOASTS } from "./constants";
export var ToastContext = /*#__PURE__*/React.createContext(null);
export var ToastContextProvider = function ToastContextProvider(_ref) {
  var children = _ref.children,
      container = _ref.container,
      maxStackedToasts = _ref.maxStackedToasts,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? ToastWrapperPosition.TOP_RIGHT : _ref$position,
      handleRemove = _ref.handleRemove;
  var getClassName = getClassNameFactory("ToastsWrapper");

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      toasts = _useState2[0],
      setToasts = _useState2[1];

  var add = useCallback(function (_ref2) {
    var text = _ref2.text,
        type = _ref2.type,
        duration = _ref2.duration;
    var id = uuid();
    var newToast = {
      id: id,
      text: text,
      type: type,
      duration: duration
    };

    if (maxStackedToasts === 1) {
      setToasts([newToast]);
      return;
    }

    setToasts(function (prevToasts) {
      return [].concat(_toConsumableArray(prevToasts.slice(-1 * (maxStackedToasts !== null && maxStackedToasts !== void 0 ? maxStackedToasts : DEFAULT_MAX_STACKED_TOASTS) + 1)), [newToast]);
    });
  }, [setToasts, maxStackedToasts]);
  var remove = useCallback(function (id) {
    setToasts(function (prevToasts) {
      return prevToasts.filter(function (toast) {
        return toast.id !== id;
      });
    });

    if (handleRemove) {
      handleRemove();
    }
  }, [setToasts]);
  var providerValue = useMemo(function () {
    return {
      add: add,
      remove: remove
    };
  }, [add, remove]);
  return /*#__PURE__*/React.createElement(ToastContext.Provider, {
    value: providerValue
  }, children, /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: position
    }),
    "aria-live": "assertive"
  }, toasts.map(function (toast) {
    return /*#__PURE__*/React.createElement(Toast, {
      key: toast.id,
      id: toast.id,
      remove: remove,
      type: toast.type,
      duration: toast.duration
    }, toast.text);
  })), container !== null && container !== void 0 ? container : document.body));
};